<template>
  <div class="dolu">
    <div class="row">
      <div class="col-lg-3 col-md-6 col-sm-6">
        <stats-card type="warning"
                    icon="fas fa-hospital"
                    small-title="Total Users"
                    :title="dabo_subjects">
          <div slot="footer">
            <i class="fas fa-info"></i>
            ---
          </div>
        </stats-card>
      </div>

      <div class="col-lg-3 col-md-6 col-sm-6">
        <stats-card type="info"
                    icon="fas fa-project-diagram"
                    small-title="Total Projects"
                    :title="dabo_projects">
          <div slot="footer">
            <i class="fas fa-info"></i>
            ---
          </div>
        </stats-card>
      </div>

      <div class="col-lg-3 col-md-6 col-sm-6">
        <stats-card type="danger"
                    icon="fas fa-vials"
                    small-title="Total Examinations"
                    :title="dabo_examinations">
          <div slot="footer">
            <i class="fas fa-info"></i>
            ---
          </div>
        </stats-card>
      </div>

      <div class="col-lg-3 col-md-6 col-sm-6">
        <stats-card type="primary"
                    icon="fas fa-expand-arrows-alt"
                    small-title="Total Mutations"
                    :title="dabo_mutations">
          <div slot="footer">
            <i class="fas fa-info"></i>
            ---
          </div>
        </stats-card>
      </div>


    </div>
<!--     <div class="row">
      <div class="col-lg-4 col-sm-6">
        <chart-card :chart-data="activeUsersChart.data"
                    chart-id="activity-chart"
                    chart-title="TOTAL EARNINGS IN LAST TEN QUARTERS">
          <span slot="title">$34,657</span>
          <badge slot="title-label" type="success">+18%</badge>

          <template slot="footer-title">Financial Statistics</template>

          <p-button slot="footer-right" aria-label="add button" type="success" round icon size="sm">
            <i class="nc-icon nc-simple-add"></i>
          </p-button>
        </chart-card>
      </div>

      <div class="col-lg-4 col-sm-6">
        <chart-card :chart-data="emailsCampaignChart.data"
                    chart-id="emails-chart"
                    color="#ef8156" chart-title="TOTAL SUBSCRIPTIONS IN LAST 7 DAYS">
          <span slot="title">169</span>
          <badge slot="title-label" type="danger">-14%</badge>

          <template slot="footer-title">View all members</template>

          <p-button slot="footer-right" aria-label="view button" type="danger" round icon size="sm">
            <i class="nc-icon nc-button-play"></i>
          </p-button>
        </chart-card>
      </div>

      <div class="col-lg-4 col-sm-6">
        <chart-card :chart-data="activeCountriesChart.data"
                    chart-id="active-countries-chart"
                    color="#fbc658" chart-title="Active Countries">
          <span slot="title">8,960</span>
          <badge slot="title-label" type="warning">~51%</badge>

          <template slot="footer-title">View more details</template>

          <p-button slot="footer-right" aria-label="view more button" type="warning" round icon size="sm">
            <i class="nc-icon nc-alert-circle-i"></i>
          </p-button>
        </chart-card>
      </div>
    </div> -->

<!-- 
    <div class="row">

      <div class="col-md-6">
        <chart-card :chart-data="activityChart.data"
                    :chart-height="200"
                    chart-id="activity-bar-chart"
                    chart-type="Bar">
          <template slot="header">
            <h4 class="card-title">Analyses by weeks in 2021</h4>
            <p class="card-category">Quality of data</p>
          </template>
          <template slot="footer">
            <div class="legend">
              <i class="fa fa-circle text-warning"></i> Low Quality and Bad
              <i class="fa fa-circle text-info"></i> Good Quality
            </div>
            <hr>
            <div class="stats">
              <i class="fa fa-check"></i> Data information certified
            </div>
          </template>
        </chart-card>
      </div>

      <div class="col-md-6">
        <chart-card :chart-data="activityChart.data"
                    :chart-height="200"
                    chart-id="activity-bar-chart"
                    chart-type="Bar">
          <template slot="header">
            <h4 class="card-title">Analyses by weeks in 2021</h4>
            <p class="card-category">Quality of data</p>
          </template>
          <template slot="footer">
            <div class="legend">
              <i class="fa fa-circle text-warning"></i> Low Quality and Bad
              <i class="fa fa-circle text-info"></i> Good Quality
            </div>
            <hr>
            <div class="stats">
              <i class="fa fa-check"></i> Data information certified
            </div>
          </template>
        </chart-card>
      </div>

    </div> -->
<!-- 
    <div class="row">
      <div class="col-3">
        <circle-chart-card :percentage="67"
                           chart-id="email-statistics-chart"
                           title="Open projects"
                           description="Number of unexamined projects"
                           color="#4acccd">
          <template slot="footer">
            <div class="legend">
              <i class="fa fa-circle text-info"></i> Open
            </div>
            <hr>
            <div class="stats">
              <i class="fa fa-calendar"></i> Show waiting 
            </div>
          </template>
        </circle-chart-card>
      </div>
 
      <div class="col-3">
        <circle-chart-card :percentage="95"
                           title="Analysis status"
                           chart-id="orders-chart"
                           description="Status of secondary analysis"
                           color="#00ff00">
          <template slot="footer">
            <div class="legend">
              <i class="fa fa-circle text-danger"></i> remaining
            </div>
            <hr>
            <div class="stats">
              <i class="fa fa-clock-o"></i> Triggered 3 hours ago
            </div>
          </template>
        </circle-chart-card>
      </div>
 
      <div class="col-3">
        <circle-chart-card :percentage="95"
                           title="Analysis status"
                           chart-id="orders-chart"
                           description="Status of secondary analysis"
                           color="#00ff00">
          <template slot="footer">
            <div class="legend">
              <i class="fa fa-circle text-danger"></i> remaining
            </div>
            <hr>
            <div class="stats">
              <i class="fa fa-clock-o"></i> Triggered 3 hours ago
            </div>
          </template>
        </circle-chart-card>
      </div>
       
      <div class="col-3">
        <circle-chart-card :percentage="95"
                           title="Analysis status"
                           chart-id="orders-chart"
                           description="Status of secondary analysis"
                           color="#00ff00">
          <template slot="footer">
            <div class="legend">
              <i class="fa fa-circle text-danger"></i> remaining
            </div>
            <hr>
            <div class="stats">
              <i class="fa fa-clock-o"></i> Triggered 3 hours ago
            </div>
          </template>
        </circle-chart-card>
      </div>
      
    </div> -->

    <div class="row">
      <div class="col-md-12 mr-auto ml-auto">
        <div class="card">
          <div class="card-header mr-auto ml-auto"> PANGO lineages
          </div>
          <div class="card-body mr-auto ml-auto">
            <slot name="title-content">
              <div class="row">
                <div class="col-sm-7">
                  <div class="numbers pull-left">
                    <slot name="title"></slot>
                  </div>
                </div>
                <div class="col-sm-5">
                  <div class="pull-right">
                    <slot name="title-label"></slot>
                  </div>
                </div>
              </div>
            </slot>
            <slot name="subtitle"></slot>
            <la-cartesian narrow  :data="dabo_pan_lineage" :width="800">
              <la-bar prop="value"></la-bar>
              <la-x-axis :fontSize="15" prop="name"></la-x-axis>
              <la-y-axis :fontSize="15" gridline></la-y-axis>
              <la-tooltip></la-tooltip>
            </la-cartesian>
          </div>

          <div class="card-footer">
            <slot name="footer">
              <hr>
              <div class="row">
                <div class="col-sm-7">
                  <div class="footer-title">
                    <slot name="footer-title"></slot>
                  </div>
                </div>
                <div class="col-sm-5">
                  <div class="pull-right">
                    <slot name="footer-right"></slot>
                  </div>
                </div>
              </div>
            </slot>
          </div>
        </div>
      </div>


      <div class="col-md-12 mr-auto ml-auto">
        <div class="card">
          <div class="card-header mr-auto ml-auto"> Clade Assignment
          </div>
          <div class="card-body mr-auto ml-auto">
            <slot name="title-content">
              <div class="row">
                <div class="col-sm-7">
                  <div class="numbers pull-left">
                    <slot name="title"></slot>
                  </div>
                </div>
                <div class="col-sm-5">
                  <div class="pull-right">
                    <slot name="title-label"></slot>
                  </div>
                </div>
              </div>
            </slot>
            <slot name="subtitle"></slot>
            <la-cartesian narrow  :data="dabo_next_clade" :width="800">
              <la-bar prop="value"></la-bar>
              <la-x-axis :fontSize="15" prop="name"></la-x-axis>
              <la-y-axis :fontSize="15" gridline></la-y-axis>
              <la-tooltip></la-tooltip>
            </la-cartesian>
          </div>

          <div class="card-footer">
            <slot name="footer">
              <hr>
              <div class="row">
                <div class="col-sm-7">
                  <div class="footer-title">
                    <slot name="footer-title"></slot>
                  </div>
                </div>
                <div class="col-sm-5">
                  <div class="pull-right">
                    <slot name="footer-right"></slot>
                  </div>
                </div>
              </div>
            </slot>
          </div>
        </div>
      </div>


    </div>

  </div>
</template>
<script>
  import CircleChartCard from 'src/components/UIComponents/Cards/CircleChartCard.vue'
  import ChartCard from 'src/components/UIComponents/Cards/ChartCard';
  import StatsCard from 'src/components/UIComponents/Cards/StatsCard';
  import LineChart from 'src/components/UIComponents/Charts/LineChart';
  import BarChart from 'src/components/UIComponents/Charts/BarChart';
  import PieChart from 'src/components/UIComponents/Charts/PieChart';
  import {Badge, Card} from 'src/components/UIComponents';
  import TaskList from './Widgets/TaskList'
  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
  import {Table, TableColumn, Divider } from 'element-ui';

  const tooltipOptions = {
    tooltipFillColor: "rgba(0,0,0,0.5)",
    tooltipFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
    tooltipFontSize: 14,
    tooltipFontStyle: "normal",
    tooltipFontColor: "#fff",
    tooltipTitleFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
    tooltipTitleFontSize: 14,
    tooltipTitleFontStyle: "bold",
    tooltipTitleFontColor: "#fff",
    tooltipYPadding: 6,
    tooltipXPadding: 6,
    tooltipCaretSize: 8,
    tooltipCornerRadius: 6,
    tooltipXOffset: 10,
  };

  export default {
    components: {
      StatsCard,
      CircleChartCard,
      Badge,
      TaskList,
      Card,
      ChartCard,
      LineChart,
      BarChart,
      PieChart,
      Table,
      TableColumn,
      Divider,
    },
    /**
     * Chart data used to render stats, charts. Should be replaced with server data
     */
    data () {
      return {
        statsCards: [
          {
            type: 'warning',
            icon: 'nc-icon nc-globe',
            title: 'Total Projects',
            value: '11',
            footerText: 'Updated now',
            footerIcon: 'nc-icon nc-refresh-69'
          },
          {
            type: 'danger',
            icon: 'nc-icon nc-vector',
            title: 'Total Examinations',
            value: 'dabo_stat_2',
            footerText: 'pre-paid',
            footerIcon: 'nc-icon nc-bell-55'
          },
          // {
          //   type: 'info',
          //   icon: 'nc-icon nc-favourite-28',
          //   title: 'Favourite Filters',
          //   value: '5',
          //   footerText: 'Updated now',
          //   footerIcon: 'nc-icon nc-refresh-69'
          // },
          // {
          //   type: 'info',
          //   icon: 'nc-icon nc-bulb-63',
          //   title: 'New mutations',
          //   value: '3',
          //   footerText: 'Updated now',
          //   footerIcon: 'nc-icon nc-refresh-69'
          // }    
        ],
        activeUsersChart: {
          data: {
            labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct"],
            series: [542, 480, 430, 550, 530, 453, 380, 434, 568, 610]
          }
        },
        emailsCampaignChart: {
          data: {
            labels: ["12pm", "3pm", "6pm", "9pm", "12am", "3am", "6am", "9am"],
            series: [40, 500, 650, 700, 1200, 1250, 1300, 1900]
          }
        },
        activeCountriesChart: {
          data: {
            labels: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October"],
            series: [80, 78, 86, 96, 83, 85, 76, 75, 88, 90]
          }
        },
        activityChart: {
          data: {
            labels: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
            datasets: [
              {
                label: "Data",
                borderColor: '#fcc468',
                fill: true,
                backgroundColor: '#fcc468',
                hoverBorderColor: '#fcc468',
                borderWidth: 10,
                data: [120, 80, 100, 90, 130, 110, 100, 80, 110, 130, 70],
              },
              {
                label: "Data",
                borderColor: '#4cbdd7',
                fill: true,
                backgroundColor: '#4cbdd7',
                hoverBorderColor: '#4cbdd7',
                borderWidth: 12,
                data: [80, 140, 50, 120, 50, 150, 60, 130, 50, 130, 150],
              }
            ]
          }
        }

      }
    },

    computed: {
      ...mapState({
        token: state => state.token,
        user: state => state.user,

        dabo_pan_lineage: state => state.dabo_pan_lineage,
        dabo_next_clade: state => state.dabo_next_clade,
        dabo_subjects: state => state.dabo_subjects,
        dabo_projects: state => state.dabo_projects,
        dabo_examinations: state => state.dabo_examinations,
        dabo_mutations: state => state.dabo_mutations,

      }),

      ...mapGetters({

      }),





    },

    methods: {
      ...mapMutations({

      }),

      ...mapActions({
        a_overview: 'a_overview',

      }),


      fetchEventsList () {
        if (this.id_project > 0) {
          this.a_examinations( {"id_project": this.id_project} );
         
        }
      },

      cancelAutoUpdate () { 
        clearInterval(this.timer) 
      },


    },


    beforeMount () {
    },

    created () {
        this.fetchEventsList();
        this.timer = setInterval(this.fetchEventsList, 3600000);

    },

    mounted () {
      // this.examinations.forEach(row => {
      //   if (row.status === 7) {
      //     this.$refs.examinationsTable.toggleRowSelection(row);
      //   }
      // });

      this.a_overview();
    },

    beforeDestroy () {
      clearInterval(this.timer)
    },

    afterDestroy () {
    },


  }

</script>
<style>

</style>
